// frontend-dash/src/utils/microTourConfigs.js
// Zentrale Definition aller kontextuellen Micro-Tours für Formulare und Detailbereiche

export const microTourConfigs = {
  'create-event': {
    id: 'create-event',
    title: 'Event-Erstellung',
    promptText: 'Neu bei der Event-Erstellung? Kurze 4-Schritte Einführung starten.',
    steps: [
      {
        target: '[data-microtour="event-basics"]',
        title: 'Grunddaten & Zeitraum',
        text: 'Gib dem Event einen aussagekräftigen Titel, wähle das Datum und bestimme die Kategorie (z. B. Zeltlager, Gruppenstunde oder Aktion).',
        tip: 'Über die Kategorie filtert die Website und der Kalender eure Termine übersichtlich.',
        placement: 'bottom'
      },
      {
        target: '[data-microtour="event-location"]',
        title: 'Veranstaltungsort & URL-Link',
        text: 'Trage den Treffpunkt oder das Zeltplatz-Gelände ein. Der URL-Slug wird automatisch für die Eventseite generiert.',
        placement: 'bottom'
      },
      {
        target: '[data-microtour="event-image"]',
        title: 'Titelbild / Flyer',
        text: 'Lade ein passendes Foto oder ein Lager-Plakat hoch. Es wird direkt auf der Startseite und in der Event-Übersicht dargestellt.',
        placement: 'bottom'
      },
      {
        target: '[data-microtour="event-registration"]',
        title: 'Anmeldung & Berechtigungen',
        text: 'Aktiviere die Online-Anmeldung, falls Eltern ihre Kinder direkt anmelden sollen. Du kannst hier auch Gesundheitsabfragen oder Einverständniserklärungen fordern.',
        tip: 'Gruppenleiter mit Berechtigung können Teilnehmerlisten und Notfallkontakte direkt im Dashboard einsehen.',
        placement: 'top'
      },
      {
        target: '[data-microtour="event-submit"]',
        title: 'Speichern & Veröffentlichen',
        text: 'Klicke auf "Event speichern". Du kannst das Event zunächst als Entwurf anlegen oder sofort auf der Website veröffentlichen.',
        placement: 'top'
      }
    ]
  },

  'create-blog': {
    id: 'create-blog',
    title: 'Blogartikel verfassen',
    promptText: 'Möchtest du die wichtigsten Funktionen des Blog-Editors kurz kennenlernen?',
    steps: [
      {
        target: '[data-microtour="blog-title"]',
        title: 'Titel & Verknüpfung',
        text: 'Wähle einen ansprechenden Titel für deinen Bericht. Du kannst den Beitrag auch direkt mit einem vergangenen Zeltlager oder einer Sippe verknüpfen.',
        tip: 'Verknüpfte Berichte erscheinen automatisch auch auf der entsprechenden Event- oder Gruppenseite.',
        placement: 'bottom'
      },
      {
        target: '[data-microtour="blog-cover"]',
        title: 'Titelbild & Galerie',
        text: 'Lade ein aussagekräftiges Foto von eurer Aktion hoch. Das Bild dient als Eyecatcher auf der Startseite.',
        placement: 'bottom'
      },
      {
        target: '[data-microtour="blog-editor"]',
        title: 'Text-Editor & Formatierung',
        text: 'Schreibe deinen Erlebnisbericht. Nutze Zwischenüberschriften, Aufzählungen oder Zitate, um den Text lebendig zu gestalten.',
        placement: 'bottom'
      },
      {
        target: '[data-microtour="blog-submit"]',
        title: 'Veröffentlichung',
        text: 'Speichere den Beitrag als Entwurf zur späteren Bearbeitung oder veröffentliche ihn direkt für alle Besucher der Website.',
        placement: 'top'
      }
    ]
  },

  'create-group': {
    id: 'create-group',
    title: 'Gruppe & Stufe anlegen',
    promptText: 'Neu hier? Schau dir kurz an, wie Gruppen und Leiter zugewiesen werden.',
    steps: [
      {
        target: '[data-microtour="group-basics"]',
        title: 'Gruppenname & Altersstufe',
        text: 'Wähle den Namen eurer Meute, Sippe oder Runde und ordne sie der passenden Stufe (Wölflinge, Jungpfadfinder, Pfadfinder, Rover) zu.',
        tip: 'Die Altersstufe bestimmt automatisch die passenden Farben und Symbole auf der Website.',
        placement: 'bottom'
      },
      {
        target: '[data-microtour="group-leaders"]',
        title: 'Gruppenleiter zuweisen',
        text: 'Weise der Gruppe ihre Gruppenleiter zu. Leiter erhalten automatisch die Berechtigung, die Sippenseite zu bearbeiten und Anwesenheitslisten zu führen.',
        placement: 'bottom'
      },
      {
        target: '[data-microtour="group-schedule"]',
        title: 'Treffzeiten & Gruppenraum',
        text: 'Hinterlege den Wochentag, die Uhrzeit und den Treffpunkt für die wöchentlichen Gruppenstunden.',
        placement: 'bottom'
      },
      {
        target: '[data-microtour="group-submit"]',
        title: 'Gruppe speichern',
        text: 'Nach dem Speichern ist die Gruppe sofort im System verfügbar und erscheint auf eurer öffentlichen Gruppen-Übersicht.',
        placement: 'top'
      }
    ]
  },

  'attendance': {
    id: 'attendance',
    title: 'Digitale Anwesenheitsliste',
    promptText: 'Möchtest du eine kurze Einführung in die Erfassung der Anwesenheit sehen?',
    steps: [
      {
        target: '[data-microtour="attendance-group"]',
        title: 'Gruppe wählen & Liste anlegen',
        text: 'Wähle eure Meute oder Sippe aus und klicke auf "Neue Anwesenheitsliste", um einen neuen Termin für die Gruppenstunde oder ein Lager anzulegen.',
        placement: 'bottom'
      },
      {
        target: '[data-microtour="attendance-history"]',
        title: 'Termine & Historie',
        text: 'Hier findest du alle bisher erfassten Gruppenstunden auf einen Blick inklusive der jeweiligen Anwesenheitsquote.',
        placement: 'right'
      },
      {
        target: '[data-microtour="attendance-list"]',
        title: 'Schnellaktionen & Erfassung',
        text: 'Klicke auf den Status eines Mitglieds (Anwesend, Entschuldigt, Unentschuldigt, Verspätet) oder nutze "Alle anwesend", um die Liste in Sekunden auszufüllen.',
        tip: 'Änderungen werden sofort automatisch im System gespeichert.',
        placement: 'left'
      }
    ]
  },

  'instagram-generator': {
    id: 'instagram-generator',
    title: 'Instagram Post & Karussell Studio',
    promptText: 'Neu im Instagram Generator? Starte die interaktive Einführung.',
    steps: [
      {
        target: '[data-microtour="ig-ai-generator"]',
        title: 'KI Magic Studio (Gemini)',
        text: 'Lass die KI aus einem Stichwort, einem Blogartikel oder einem Event ein fertiges mehrseitiges Karussell inklusive Überschriften, Texten und Zitatfolien generieren.',
        tip: 'Wähle eine Vorlage (z. B. "Lager-Rückblick" oder "Event-Ankündigung"), um sofort die passende Folienstruktur zu erhalten.',
        placement: 'bottom'
      },
      {
        target: '[data-microtour="ig-slide-editor"]',
        title: 'Live Canvas & Folienbearbeitung',
        text: 'Hier siehst du die exakte Vorschau im 4:5 Portraitformat (1080x1350px). Klicke auf Folien, um Texte, Layouts, Abzeichen und Sprechblasen in Echtzeit anzupassen.',
        placement: 'bottom'
      },
      {
        target: '[data-microtour="ig-customizer"]',
        title: 'Farben, CI & Stammeswappen',
        text: 'Passe Hintergrundfarben, Verläufe, Kontrastmodi und euer Stammeswappen an. Das Design orientiert sich automatisch an eurer Stammes-CI.',
        tip: 'Du kannst auch eigene Fotos hochladen oder lizenzfreie Unsplash-Bilder direkt einbinden.',
        placement: 'left'
      },
      {
        target: '[data-microtour="ig-caption-tool"]',
        title: 'Caption & Pfadfinder-Hashtags',
        text: 'Hier findest du den passenden Begleittext für deinen Instagram-Post mit passenden Emojis und optimierten Hashtags zum einfachen Kopieren.',
        placement: 'top'
      },
      {
        target: '[data-microtour="ig-export-actions"]',
        title: 'Export & ZIP-Download',
        text: 'Lade die aktuelle Folie als hochauflösendes PNG herunter oder exportiere das gesamte Karussell mit einem Klick als gezipptes Paket für Instagram.',
        placement: 'top'
      }
    ]
  },

  'admin-integrations': {
    id: 'admin-integrations',
    title: 'Schnittstellen & Secrets',
    promptText: 'Möchtest du sehen, wie E-Mail, KI und Cloud-Dienste angebunden werden?',
    steps: [
      {
        target: '[data-microtour="integration-email"]',
        title: 'E-Mail-Versand (Resend API)',
        text: 'Hinterlege deinen Resend API-Key und die Absender-Adresse (z. B. post@mein-stamm.de), damit das System Anmeldebestätigungen und Einladungen verschicken kann.',
        tip: 'Über den Button "Verbindung testen" kannst du direkt eine Test-Mail an dich selbst senden.',
        placement: 'bottom'
      },
      {
        target: '[data-microtour="integration-ai"]',
        title: 'Google Gemini & KI-Modelle',
        text: 'Verbinde Google Gemini mit deinem API-Schlüssel, um den Stammes-Chatbot "Bob" und die automatische Texterstellung im Dashboard zu aktivieren.',
        placement: 'top'
      },
      {
        target: '[data-microtour="integration-cloudflare"]',
        title: 'Cloudflare & Datenbank',
        text: 'Konfiguriere API-Token und Zone-IDs für automatische DNS-Verwaltung, SSL-Zertifikate und die Cloudflare D1 Serverless-Datenbank.',
        placement: 'top'
      },
      {
        target: '[data-microtour="integration-save"]',
        title: 'Einstellungen sichern',
        text: 'Klicke auf "Speichern", um die Schlüssel verschlüsselt zu hinterlegen. Ungültige Schlüssel werden bei Verbindungstests sofort markiert.',
        placement: 'top'
      }
    ]
  },

  'material-management': {
    id: 'material-management',
    title: 'Material- & Zeltverwaltung',
    promptText: 'Kurze Tour durch die Material- und Zeltverwaltung starten?',
    steps: [
      {
        target: '[data-microtour="material-stats"]',
        title: 'Bestandsübersicht & Lagerorte',
        text: 'Behalte den Überblick über Kohten, Jurten, Werkzeuge, Küchenkisten und deren aktuellen Standort (Heim, Schuppen, Privat).',
        placement: 'bottom'
      },
      {
        target: '[data-microtour="material-filter"]',
        title: 'Kategorien & Zustandsfilter',
        text: 'Filtere dein Inventar gezielt nach Zeltmaterial, Kochgeschirr, Werkzeug oder nach Reparaturbedarf.',
        placement: 'bottom'
      },
      {
        target: '[data-microtour="material-add"]',
        title: 'Neues Material erfassen',
        text: 'Lege neue Ausrüstungsgegenstände mit Menge, Zustand, Lagerort und Fotos an.',
        tip: 'Du kannst auch Barcodes oder Seriennummern hinterlegen.',
        placement: 'bottom'
      },
      {
        target: '[data-microtour="material-tabs"]',
        title: 'Ausleihe & Reparatur-Tracking',
        text: 'Wechsle zwischen Bestandsliste, aktiven Ausleihen an Gruppenleiter und der Reparatur-Warteschlange.',
        placement: 'bottom'
      }
    ]
  },

  'finance-management': {
    id: 'finance-management',
    title: 'Finanzen & Kassenbuch',
    promptText: 'Möchtest du eine kurze Einführung in das digitale Kassenbuch sehen?',
    steps: [
      {
        target: '[data-microtour="finance-overview"]',
        title: 'Kassenstände & Gesamtsaldo',
        text: 'Hier siehst du auf einen Blick den aktuellen Saldo aller Konten: Girokonto, Barkasse und zweckgebundene Lagerkassen.',
        placement: 'bottom'
      },
      {
        target: '[data-microtour="finance-add"]',
        title: 'Einnahme oder Ausgabe buchen',
        text: 'Erfasse neue Buchungen mit Betrag, Kategorie, Zahlungsart und lade den digitalen Beleg/Quittung direkt hoch.',
        tip: 'Belege werden sicher archiviert und stehen für die Kassenprüfung sofort bereit.',
        placement: 'bottom'
      },
      {
        target: '[data-microtour="finance-transactions"]',
        title: 'Buchungshistorie & Filter',
        text: 'Durchsuche alle Buchungen nach Zeitraum, Kategorie oder Event. Korrigiere oder storniere Buchungen bei Bedarf.',
        placement: 'top'
      }
    ]
  },

  'tasks': {
    id: 'tasks',
    title: 'Aufgaben & Leiterrunden-To-Dos',
    promptText: 'Neu im Aufgabenplaner? Starte die kurze Einführung.',
    steps: [
      {
        target: '[data-microtour="tasks-stats"]',
        title: 'Aufgaben-Status im Überblick',
        text: 'Hier siehst du offene, in Bearbeitung befindliche und erledigte Aufgaben deiner Leiterrunde auf einen Blick.',
        placement: 'bottom'
      },
      {
        target: '[data-microtour="tasks-create"]',
        title: 'Neue Aufgabe anlegen',
        text: 'Erstelle Aufgaben mit Fälligkeitsdatum, Priorität und weise sie direkt einem oder mehreren Leitern zu.',
        placement: 'bottom'
      },
      {
        target: '[data-microtour="tasks-list"]',
        title: 'Aufgabenliste & Schnellaktionen',
        text: 'Markiere erledigte Aufgaben mit einem Klick, bearbeite Details oder passe Fälligkeiten an.',
        placement: 'top'
      }
    ]
  },

  'homepage-settings': {
    id: 'homepage-settings',
    title: 'Startseiten-Baukasten',
    promptText: 'Möchtest du sehen, wie du eure Homepage nach euren Wünschen anpasst?',
    steps: [
      {
        target: '[data-microtour="homepage-sections"]',
        title: 'Sektionen & Modul-Reihenfolge',
        text: 'Aktiviere, deaktiviere oder verschiebe die Abschnitte eurer Startseite (Hero-Banner, Stufenübersicht, Event-Vorschau, Blog-Karussell, Spendenaufruf).',
        placement: 'bottom'
      },
      {
        target: '[data-microtour="homepage-branding"]',
        title: 'Stammeswappen & Identität',
        text: 'Hinterlege euren Stammesnamen, Bundeszugehörigkeit, Slogan und lade euer offizielles Wappen oder Logo hoch.',
        placement: 'bottom'
      },
      {
        target: '[data-microtour="homepage-colors"]',
        title: 'Farbschema & Dark Mode',
        text: 'Wähle eure Primärfarben oder lass die passenden Farbtöne automatisch aus eurem Logo extrahieren.',
        placement: 'bottom'
      },
      {
        target: '[data-microtour="homepage-save"]',
        title: 'Live-Veröffentlichung',
        text: 'Klicke auf "Speichern", um alle Änderungen ohne Verzögerung direkt auf eurer Website zu veröffentlichen.',
        placement: 'bottom'
      }
    ]
  },

  'registration-codes': {
    id: 'registration-codes',
    title: 'Registrierungscodes & Einladungen',
    promptText: 'Kurze Einführung zur Erstellung von Einladungscodes für Leiter und Eltern starten?',
    steps: [
      {
        target: '[data-microtour="codes-create-form"]',
        title: 'Neuen Code generieren',
        text: 'Wähle einen einprägsamen Code (z.B. "SOMMER-2026"), die zugewiesene Rolle (Gruppenleiter, Elternteil, Mitglied) und optional eine feste Sippe.',
        tip: 'Du kannst auch ein Ablaufdatum und ein Nutzungslimit festlegen.',
        placement: 'bottom'
      },
      {
        target: '[data-microtour="codes-table"]',
        title: 'Aktive Codes & Nutzungskontrolle',
        text: 'Hier siehst du alle aktiven Codes, wie oft sie bereits eingelöst wurden und wer sie erstellt hat.',
        placement: 'top'
      },
      {
        target: '[data-microtour="codes-share"]',
        title: 'Einladungslink teilen',
        text: 'Kopiere den direkten Registrierungslink oder zeige den QR-Code auf der Leiterrunde zum schnellen Beitritt.',
        placement: 'left'
      }
    ]
  },

  'admin-bob': {
    id: 'admin-bob',
    title: 'Bob KI-Assistent & Stammeswissen',
    promptText: 'Möchtest du Bob mit individuellem Stammeswissen und Richtlinien ausstatten?',
    steps: [
      {
        target: '[data-microtour="bob-personality"]',
        title: 'Persönlichkeit & Begrüßung',
        text: 'Bestimme, wie Bob Besucher und Leiter anspricht (z. B. locker, pfadfinderisch "Gut Pfad") und wie er sich vorstellt.',
        placement: 'bottom'
      },
      {
        target: '[data-microtour="bob-knowledge"]',
        title: 'Stammeswissen einspeisen',
        text: 'Hinterlege wichtige Informationen über euren Stamm: Treffpunkte, Mitgliedsbeiträge, Zeltlager-Packlisten und Ansprechpartner.',
        tip: 'Je genauer das Wissen hinterlegt ist, desto präziser beantwortet Bob Fragen von Eltern und Interessierten.',
        placement: 'bottom'
      },
      {
        target: '[data-microtour="bob-channels"]',
        title: 'Kanäle & Aktivierung',
        text: 'Bestimme, ob Bob auf der öffentlichen Website für Besucher, im internen Dashboard oder in beiden Bereichen aktiv sein soll.',
        placement: 'top'
      }
    ]
  }
};
